import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  role: "list",
  class: "bg-zinc-900"
}
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = { class: "text-xs font-semibold text-zinc-900 dark:text-white" }
const _hoisted_4 = { class: "relative mt-3 pl-2" }
const _hoisted_5 = {
  role: "list",
  class: "border-l border-transparent"
}
const _hoisted_6 = { class: "relative" }
const _hoisted_7 = { class: "truncate" }
const _hoisted_8 = {
  key: 0,
  role: "list",
  style: {"opacity":"1"}
}
const _hoisted_9 = { class: "relative" }
const _hoisted_10 = { class: "truncate" }
const _hoisted_11 = { class: "relative mt-6 bg-zinc-900" }
const _hoisted_12 = { class: "text-xs font-semibold text-zinc-900 dark:text-white" }
const _hoisted_13 = { class: "relative mt-3 pl-2" }
const _hoisted_14 = {
  role: "list",
  class: "border-l border-transparent"
}
const _hoisted_15 = { class: "relative" }
const _hoisted_16 = { class: "truncate" }
const _hoisted_17 = { class: "relative mt-6 bg-zinc-900" }
const _hoisted_18 = { class: "text-xs font-semibold text-zinc-900 dark:text-white" }
const _hoisted_19 = { class: "relative mt-3 pl-2" }
const _hoisted_20 = {
  role: "list",
  class: "border-l border-transparent"
}
const _hoisted_21 = { class: "relative" }
const _hoisted_22 = { class: "truncate" }
const _hoisted_23 = { class: "opacity-50 ml-1" }
const _hoisted_24 = { class: "relative mt-6 bg-zinc-900" }
const _hoisted_25 = { class: "text-xs font-semibold text-zinc-900 dark:text-white" }
const _hoisted_26 = { class: "relative mt-3 pl-2" }
const _hoisted_27 = {
  role: "list",
  class: "border-l border-transparent"
}
const _hoisted_28 = { class: "relative" }
const _hoisted_29 = { class: "truncate" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SidebarLink = _resolveComponent("SidebarLink")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass([
			'lg:mt-10 lg:block pt-16 pl-4 md:mt-0 md:pl-0 transition-transform duration-200 z-10 absolute inset-0 bg-zinc-900 lg:relative min-h-screen lg:min-h-0',
			_ctx.mobileNavigationDisplayed ? 'translate-x-0' : '-translate-x-full lg:translate-x-0',
		])
  }, [
    _createElementVNode("ul", _hoisted_1, [
      _createElementVNode("li", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: _ctx.docsRoute(_ctx.DocsRoute.INDEX)
          }, {
            default: _withCtx(() => [
              _createTextVNode("Guides")
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["to"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sidebarDocsPages, (page) => {
              return (_openBlock(), _createElementBlock("li", _hoisted_6, [
                _createVNode(_component_SidebarLink, {
                  class: "flex justify-between gap-2 py-1 pr-3 text-sm transition pl-4 hover:text-zinc-900 dark:hover:text-white hover:bg-zinc-800/50",
                  inactiveClass: 'text-zinc-600 dark:text-zinc-400',
                  activeClass: 'text-white bg-zinc-800',
                  to: _ctx.docsRoute(page.route)
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(page.name), 1 /* TEXT */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
                (page.children && page.children.length && _ctx.routeMatchesCurrent(page.route))
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(page.children, (childPage) => {
                        return (_openBlock(), _createElementBlock("li", _hoisted_9, [
                          _createVNode(_component_SidebarLink, {
                            class: "flex justify-between gap-2 py-1 pr-3 text-sm transition pl-7 hover:text-zinc-900 dark:hover:text-white hover:bg-zinc-800/50",
                            inactiveClass: 'text-zinc-600 dark:text-zinc-400',
                            activeClass: 'text-white bg-zinc-800',
                            to: _ctx.docsRoute(childPage.route)
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_10, _toDisplayString(childPage.name), 1 /* TEXT */)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                        ]))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ]))
            }), 256 /* UNKEYED_FRAGMENT */))
          ])
        ])
      ]),
      _createElementVNode("li", _hoisted_11, [
        _createElementVNode("h2", _hoisted_12, [
          _createVNode(_component_router_link, {
            to: _ctx.docsRoute(_ctx.DocsRoute.EXAMPLES)
          }, {
            default: _withCtx(() => [
              _createTextVNode("Examples")
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["to"])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_13, [
          _createElementVNode("ul", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.EXAMPLE_CATEGORIES, (category) => {
              return (_openBlock(), _createElementBlock("li", _hoisted_15, [
                _createVNode(_component_SidebarLink, {
                  class: "flex justify-between gap-2 py-1 pr-3 text-sm transition pl-4 hover:text-zinc-900 dark:hover:text-white hover:bg-zinc-800/50",
                  inactiveClass: 'text-zinc-600 dark:text-zinc-400',
                  activeClass: 'text-white bg-zinc-800',
                  to: _ctx.docsExampleCategoryPath(category)
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_16, _toDisplayString(category), 1 /* TEXT */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
              ]))
            }), 256 /* UNKEYED_FRAGMENT */))
          ])
        ], 512 /* NEED_PATCH */), [
          [_vShow, _ctx.examplesExpanded]
        ])
      ]),
      _createElementVNode("li", _hoisted_17, [
        _createElementVNode("h2", _hoisted_18, [
          _createVNode(_component_router_link, {
            to: _ctx.docsRoute(_ctx.DocsRoute.NODES)
          }, {
            default: _withCtx(() => [
              _createTextVNode("Nodes")
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["to"])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_19, [
          _createElementVNode("ul", _hoisted_20, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documentedNodeContexts, (nodeContext) => {
              return (_openBlock(), _createElementBlock("li", _hoisted_21, [
                _createVNode(_component_SidebarLink, {
                  class: "flex justify-between gap-2 py-1 pr-3 text-sm transition pl-4 hover:text-zinc-900 dark:hover:text-white hover:bg-zinc-800/50",
                  inactiveClass: 'text-zinc-600 dark:text-zinc-400',
                  activeClass: 'text-white bg-zinc-800',
                  to: _ctx.docsNodeContext(nodeContext)
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_22, [
                      _createElementVNode("span", null, _toDisplayString(nodeContext.toUpperCase()), 1 /* TEXT */),
                      _createElementVNode("span", _hoisted_23, "- " + _toDisplayString(_ctx.NODE_CONTEXT_LABEL[nodeContext]), 1 /* TEXT */)
                    ])
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
              ]))
            }), 256 /* UNKEYED_FRAGMENT */))
          ])
        ], 512 /* NEED_PATCH */), [
          [_vShow, _ctx.nodesExpanded]
        ])
      ]),
      _createElementVNode("li", _hoisted_24, [
        _createElementVNode("h2", _hoisted_25, [
          _createVNode(_component_router_link, {
            to: _ctx.docsRoute(_ctx.DocsRoute.EXPRESSIONS)
          }, {
            default: _withCtx(() => [
              _createTextVNode("Expressions")
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["to"])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_26, [
          _createElementVNode("ul", _hoisted_27, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expressionNames, (expressionName) => {
              return (_openBlock(), _createElementBlock("li", _hoisted_28, [
                _createVNode(_component_SidebarLink, {
                  class: "flex justify-between gap-2 py-1 pr-3 text-sm transition pl-4 hover:text-zinc-900 dark:hover:text-white hover:bg-zinc-800/50",
                  inactiveClass: 'text-zinc-600 dark:text-zinc-400',
                  activeClass: 'text-white bg-zinc-800',
                  to: _ctx.docsExpression(expressionName)
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_29, [
                      _createElementVNode("span", null, _toDisplayString(expressionName), 1 /* TEXT */)
                    ])
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
              ]))
            }), 256 /* UNKEYED_FRAGMENT */))
          ])
        ], 512 /* NEED_PATCH */), [
          [_vShow, _ctx.expressionsExpanded]
        ])
      ])
    ])
  ], 2 /* CLASS */))
}